import { getApiClient } from '@src/services/api-client'
import { MutationFunction, useMutation } from '@tanstack/react-query'
import { makeGetCsv } from '../make-api'

const REPORT_ACT = '/ReportAct'

const reportActApiLegacy = makeGetCsv(REPORT_ACT)

async function downloadReportAct() {
  const apiClient = getApiClient()
  return reportActApiLegacy(apiClient)
}

export function useReportActExport(): [MutationFunction<void, void>, boolean] {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: downloadReportAct,
  })

  return [mutateAsync, isPending]
}

